export function validateFacilityForm(form) {
  const errors = {};

  if (!form.name.trim()) errors.name = "Name is required.";
  if (!form.description.trim()) errors.description = "Description is required.";
  if (!form.timezone.trim()) errors.timezone = "Time zone is required.";
  if (!form.referral_code.trim()) errors.referral_code = "Referral code is required.";

  if (!form.api_rate_limit) {
    errors.api_rate_limit = "API rate limit is required.";
  } else if (!/^\d+$/.test(form.api_rate_limit)) {
    errors.api_rate_limit = "API rate limit must be an integer.";
  }

  const optionalIntegerFields = {
    web_search_limit: "Websearch limit",
    intranet_search_limit: "Intranet search limit",
    project_limit: "Project limit",
    collection_limit: "Collection limit",
  };
  Object.entries(optionalIntegerFields).forEach(([field, label]) => {
    if (form[field] && !/^\d+$/.test(form[field])) {
      errors[field] = `${label} must be an integer.`;
    }
  });

  if (form.phone_number && !/^\d+$/.test(form.phone_number)) {
    errors.phone_number = "Phone number must be numeric.";
  }

  return errors;
}
